import React from "react";
import { ErrorBoundary } from "react-error-boundary";

import { t } from "../../utils/ResourceUtils";
import ErrorUI from "../error-page/ErrorUI";

const AppErrorBoundary = ({ children }) => {
  const FallbackComponent = ({ error }) => {
    const errorMessage = error?.message || t("cm.an_err");
    const errorStack = error?.stack || "";
    return <ErrorUI errorMessage={errorMessage} errorStack={errorStack} />;
  };

  return <ErrorBoundary FallbackComponent={FallbackComponent}>{children}</ErrorBoundary>;
};

export default AppErrorBoundary;
